export const getInitialMemberIds = ({ ownerId, currentUserId }) => [
  (ownerId && ownerId !== 'me') ? ownerId : currentUserId
]
